export const TUTORIAL_MENU_ID = 11; // id from menu element table
